import tracker from 'src/libs/tracker';

/**
 * Tracks a redirection event by sending the source and the target.
 * It's assumed (but not enforced) that these values are URLs
 */
export default (source, target) => {
  tracker.trackBabbelTracker('lead_funnel:redirected', 5, { source, target });
};
